var l={SMALL:"small",REGULAR:"regular",LARGE:"large",TINY:"tiny",FULLWIDTH:"full-width"};export{l as ESize};
//# sourceMappingURL=size.mjs.map
